<template>
    
   <div class="page">
        <div class="header">
            大工
        </div>

        <div class="content">
            <block v-for="(item, index) in dgList" :key="item._id">
                <div class="userItem">
                    <div v-if="dg._id === item._id" class="checkZd">
                        <t-switch v-model="dg.zd" :label="['指', '指']"
                            :custom-style="{ margin: '0 10rpx' }" @onChange="(val) => onSwitchChange('dg', val)" />
                    </div>
                    <div @click="choseThisService('dg', index)" class="item"
                        :class="{ checked: dg._id === item._id }">
                        {{ item.name }}
                    </div>
                </div>
            </block>
        </div>


        <div class="header">
            中工
        </div>
        <div class="content">
            <block v-for="(item, index) in zgList" :key="item._id">
                <div class="userItem">
                    <div v-if="zg._id === item._id" class="checkZd">
                        <t-switch v-model="zg.zd" :label="['指', '指']"
                            :custom-style="{ margin: '0 10rpx' }" @onChange="(val) => onSwitchChange('zg', val)" />
                    </div>
                    <div @click="choseThisService('zg', index)" class="item"
                        :class="{ checked: zg._id === item._id }">
                        {{ item.name }}
                    </div>
                </div>
            </block>
        </div>


        <div class="header">
            小工
        </div>
        <div class="content">
            <block v-for="(item, index) in xgList" :key="item._id">
                <div class="userItem">
                    <div v-if="xg._id === item._id" class="checkZd">
                        <t-switch v-model="xg.zd" :label="['指', '指']"
                            :custom-style="{ margin: '0 10rpx' }" @onChange="(val) => onSwitchChange('xg', val)" />
                    </div>
                    <div @click="choseThisService('xg', index)" class="item"
                        :class="{ checked: xg._id === item._id }">
                        {{ item.name }}
                    </div>
                </div>
            </block>
        </div>

        <div class="footerBar">
            <t-button class="confirmBtn" size="large" theme="primary" @click="doConfirm">确 定</t-button>
        </div>
    </div>  
</template>

<script>
import { ref, reactive, getCurrentInstance } from 'vue'
import { stateShop } from '@/store'
export default {
    name: 'ChoseService',
    props: {
        // 从父组件传入的初始数据
        productItem: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['confirm'],
    setup(props, { emit }) {
         const { proxy } = getCurrentInstance();
        const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase

        // 响应式数据
        const dgList = ref([])
        const zgList = ref([])
        const xgList = ref([])
        const commissionList = ref([])
        const dg = reactive({});
        const zg = reactive({});
        const xg = reactive({});
        const achievement_role = reactive({});


        const loadShopUser = async () => {
            console.log(app,343,stateShop);
            const db = app.database();
            let shopId = stateShop._id;
            let userList = await db.collection("my_user").where({
                deleted: 0,
                active: true,
                shopId
            }).field({
                _id: true,
                jobType: true,
                role: true,
                roleId: true,
                name: true
            }).get().then(res => {
                return res.data;
            })

            xgList.value = userList.filter(item => {
                return item.jobType.indexOf('小工') >= 0;
            })
            zgList.value = userList.filter(item => {
                return item.jobType.indexOf('中工') >= 0;
            })
            dgList.value = userList.filter(item => {
                return item.jobType.indexOf('大工') >= 0;
            })
            ///看看有没有选好的


            let { ticheng } = props.productItem;

            if (ticheng) {
                for (let item of ticheng) {
                    if (item.type == "dg")

                        Object.assign(dg, item);
                    else if (item.type == "zg")

                        Object.assign(zg, item);
                    else if (item.type == "xg")
                        Object.assign(xg, item);
                }
            }



        };

        const loadShopYeJiRole = async () => {
            const db = app.database();
            let shopId = stateShop._id;
            let result = await db.collection("my_achievement_role").where({
                shopId
            }).get().then(res => {
                return res.data;
            });
            if (result.length)

                Object.assign(achievement_role, result[0])


        };


        const loadCommissionData = (job_type, user) => {

            let designation = '非指定';
            switch (job_type) {
                case '大工':
                    designation = dg.zd ? '指定' : '非指定';
                    break;
                case '中工':
                    designation = zg.zd ? '指定' : '非指定';
                    break;
                case '小工':
                    designation = xg.zd ? '指定' : '非指定';
                    break;
            }
            // let pay_type = this.data.cartItem.pay_type;
            let commission_list = commissionList.value.filter(item => {
                return (item.job_type.length == 0 || item.job_type.indexOf(job_type) >= 0) &&
                    // (item.pay_type.length == 0 || item.pay_type.indexOf(pay_type.name) >= 0) &&
                    (item.designation.length == 0 || item.designation.indexOf(designation) >= 0) &&
                    (item.role_type.length == 0 || item.role_type.indexOf(user.role) >= 0);
            });

            if (commission_list.length) {
                let {
                    commissionId,
                    commissionType,
                    commissionType2,
                    commissionValue
                } = commission_list[0];
                user.commission = {
                    commissionId,
                    commissionType,
                    commissionType2,
                    commissionValue,

                };
                user.designation = designation;

                return user;
            } else {
                user.commission = null;
                return user;
            }

        };
 


        const doConfirm = () => {




            //哪个产品  哪个工种   哪个支付方式   多少钱  //余额  次卡   
            let list = [];
            if (dg._id) {

                list.push({
                    type: 'dg',
                    tichengAmount: 0,
                    ...dg,
                    yejiPercent: 100
                });
            }

            if (zg._id) {
                list.push({
                    type: 'zg',
                    tichengAmount: 0,
                    ...zg,
                    yejiPercent: 100
                });
            }

            if (xg._id) {
                list.push({
                    type: 'xg',
                    tichengAmount: 0,
                    ...xg,
                    yejiPercent: 100
                });

            }

            if (achievement_role.type == 0 && list.length) {

                let percentValue = (1 / list.length).toFixed(2)

                list.forEach(item => {
                    item.yejiPercent = percentValue;
                })
            }


            emit('confirm', list);


        };


        const choseThisService = (type, index) => {
     console.log(index, type );
     
            if (type == "dg") {
                let item = dgList.value[index];
                item.zd = false;
                item.designation = '非指定';
                if (item._id == dg._id)
                    item = {
                        _id: ''
                    }
                else
                    item = loadCommissionData('大工', item)

                Object.assign(dg, item);
                    console.log(index, type,dg,item);

            } else if (type == "zg") {
                let item = zgList.value[index];
                item.zd = false,
                    item.designation = '非指定'
                if (item._id == zg._id)
                    item = {
                        _id: ''
                    }
                else
                    item = loadCommissionData('中工', item);
                Object.assign(zg, item);

            } else if (type == "xg") {
                let item = xgList.value[index];

                item.zd = false,
                    item.designation = '非指定'
                if (item._id == xg._id)
                    item = {
                        _id: ''
                    }
                else
                    item = loadCommissionData('小工', item);
                Object.assign(xg, item);

            }

        };


        // 指定开关变更
        const onSwitchChange = (type) => {
            
console.log(type);
       switch (type) {
        case "dg":

          dg.zd = !dg.zd;
          loadCommissionData(type, dg);
          break;
        case "zg":

          zg.zd = !zg.zd;
          loadCommissionData(type, zg);
          break;
        case "xg":

          xg.zd = !xg.zd;
          loadCommissionData(type, xg);
      }


    
        }

        // 确认选择


        const loadCommission = async () => {
            const db = app.database();
            let prouductId = props.productItem._id;
            let shopId = stateShop._id;
            const _ = db.command;

            //就是进来时就带上pay_type
            commissionList.value = await db.collection('my_commission').where({
                shopId,
                status: 2,
                productIds: _.all([prouductId])
            })
                .get().then(res => {

                    return res.data;
                })


        };



        loadShopUser();
        loadCommission();
   
         loadShopYeJiRole();
        // 暴露给模板的数据和方法
        return {
            dgList,
            zgList,
            xgList,
            dg,
            zg,
            xg,
    
            choseThisService,
            onSwitchChange,
            doConfirm
        }
    }
}
</script>

<style scoped>
/* pages/meiye/choseService/index.wxss */
.page {
    background-color: white;
    padding: 2vw;
    box-sizing: border-box;
}

.title {
    padding: 2vw;
    font-weight: 700;

}

.smallBtn {
    font-size: 0.8rem;
    color: rgb(80, 80, 80);
    padding-right: 16px;
}

.content {

    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 6vw;

}

.userItem {
    position: relative;
    display: flex;
    align-items: center;
}



.custom-tabs {
    width: 90vw;
    --tab-font-size: 32px;
    border-bottom: none;

}

.box {
    width: 90vw;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
}


.content .item {
    padding: 1vw 0;
    width: 19vw;
    text-align: center;
    box-sizing: border-box;
    height: 9vw;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3vw 2vw;
    color: rgb(65, 65, 65);
    background-color: rgb(243, 243, 243);
    border: 1px solid rgb(243, 243, 243);
}

.content .checked {

    border: 1px solid rgb(19, 19, 19);
    font-weight: 700;
    border-bottom: 0;
}

.userItem .checkZd {
    position: absolute;
    top: 11vw;
    left: 2vw;
    width: 19vw;
    height: 9vw;
    box-sizing: border-box;
    background-color: rgb(243, 243, 243);
    padding-top: 1vw;

    color: gray;
    border: 1px solid rgb(19, 19, 19);
    border-top: 0;
    padding: 2px 1vw;
    z-index: 600;
    display: flex;
    justify-content: center;

}

switch {
    width: 30rpx !important;
    height: 30rpx !important;
    margin-right: 2vw;
}

.footerBar {
    display: flex;
    justify-content: end;
}
</style>